import { ScrollText } from "lucide-react";

const SECTIONS = [
  {
    title: "Finalità e Natura del Servizio",
    body: "L'applicazione è uno strumento esclusivo di analisi statistica e calcolo probabilistico. I dati e le proiezioni forniti non costituiscono garanzia di vincita o successo finanziario e non incoraggiano in alcun modo il gioco d'azzardo.",
  },
  {
    title: "Limitazione di Responsabilità",
    body: "L'utente utilizza il software sotto la propria e totale responsabilità. Sviluppatori, distributori e partner declinano ogni responsabilità per perdite finanziarie, danni o sanzioni derivanti dall'uso del software o dall'interpretazione delle informazioni.",
  },
  {
    title: "Requisiti di Età e Registrazione",
    body: "L'accesso è riservato esclusivamente a soggetti maggiorenni (18+). È fatto divieto assoluto ai minori di età. L'utente garantisce la veridicità dei propri dati anagrafici.",
  },
  {
    title: "Come funziona",
    body: "L'accesso al servizio avviene tramite un codice univoco associato in modo esclusivo a un singolo dispositivo. È vietato condividere o cedere il proprio codice a terzi. L'utente è responsabile della sicurezza del proprio dispositivo e delle credenziali di accesso.",
  },
  {
    title: "Sospensione e Revoca",
    body: "Gli sviluppatori si riservano il diritto insindacabile di bloccare l'accesso o revocare la licenza, in qualsiasi momento e senza preavviso, in caso di violazione dei termini, usi impropri, condivisione non autorizzata dei codici di accesso o condotte illecite, senza alcun obbligo di rimborso.",
  },
  {
    title: "Conformità e Gioco Responsabile",
    body: "L'utente è tenuto al rispetto delle normative locali vigenti. In presenza di problematiche legate al gioco, si invita a consultare centri di supporto specializzati. Gioca responsabilmente.",
  },
  {
    title: "Privacy e Trattamento dei Dati (GDPR - Regolamento UE 2016/679)",
    body: "I dati personali eventualmente raccolti per la gestione degli account e l'erogazione del servizio sono trattati nel rispetto della normativa vigente sulla privacy. L'utente ha il diritto di accedere ai propri dati, richiederne la rettifica o la cancellazione secondo le modalità indicate nell'informativa privacy dedicata.",
  },
  {
    title: "Cookie e Tecnologie di Tracciamento",
    body: "L'applicazione e le eventuali piattaforme web collegate possono fare uso di cookie tecnici o strumenti di analisi per garantire il corretto funzionamento delle sessioni e migliorare l'esperienza utente.",
  },
  {
    title: "Accettazione dei Termini",
    body: "L'attivazione e l'uso dell'app implicano l'accettazione integrale delle presenti condizioni. In caso di disaccordo, è fatto obbligo di cessare l'utilizzo e disinstallare il software.",
  },
];

export default function DisclaimerModal({ readOnly = false, onAccept, onReject, onClose }) {
  return (
    <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center px-4 py-8 overflow-y-auto">
      <div data-testid="disclaimer-modal" className="w-full max-w-lg bg-black border-2 border-[#E3BC55] rounded-2xl gold-glow fade-up">
        <div className="px-6 py-5 border-b border-amber-500/20 flex items-center gap-2.5">
          <ScrollText className="w-5 h-5 text-[#E3BC55]" />
          <h2 className="font-heading font-bold text-lg text-[#E3BC55] uppercase tracking-wide">
            Informativa e Scarico di Responsabilità
          </h2>
        </div>
        <div className="px-6 py-5 max-h-[50vh] overflow-y-auto space-y-4">
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h3 className="text-sm font-heading font-bold text-[#E3BC55] mb-1">{s.title}</h3>
              <p className="text-sm text-slate-300 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
        <div className="px-6 py-5 border-t border-amber-500/20">
          {readOnly ? (
            <button
              data-testid="disclaimer-close-button"
              onClick={onClose}
              className="w-full py-3 rounded-xl bg-[#E3BC55] text-black font-heading font-bold uppercase tracking-widest text-sm hover:bg-[#FFD700] transition-colors"
            >
              Ho Capito
            </button>
          ) : (
            <div className="grid grid-cols-2 gap-3">
              <button
                data-testid="disclaimer-reject-button"
                onClick={onReject}
                className="py-3 rounded-xl border-2 border-red-500/50 text-red-400 font-heading font-bold uppercase tracking-widest text-sm hover:bg-red-500/10 transition-colors"
              >
                Rifiuto
              </button>
              <button
                data-testid="disclaimer-accept-button"
                onClick={onAccept}
                className="py-3 rounded-xl bg-[#E3BC55] text-black font-heading font-bold uppercase tracking-widest text-sm hover:bg-[#FFD700] transition-colors"
              >
                Accetto
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
